import { TriggerBuilder } from '../components/TriggerBuilder';
import type { AgentTemplateWizardStepType, WizardDraft, WizardStepProps } from '../types';

type TriggersIntent = WizardDraft['triggers'];

/**
 * `attach-webhook` step (design §14.1): cron/webhook/event intents collected
 * locally; each is POSTed post-create via `POST /agent/factories/:id/triggers`
 * (P2-T3 routes). The webhook URL is revealed once in the attach sequence
 * (§15.3/§17.4) — the backend returns no signing secret on this path, so the
 * panel shows the URL only (Q1 resolved at T6).
 */
function AttachWebhookStep({ value, onChange }: WizardStepProps) {
  const triggers: TriggersIntent =
    value && typeof value === 'object' && 'items' in (value as TriggersIntent)
      ? (value as TriggersIntent)
      : { items: [] };

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Run the agent on a schedule, when an external webhook fires, or on a platform event.
      </p>
      <TriggerBuilder
        items={triggers.items}
        onChange={(items) => onChange({ ...triggers, items })}
      />
    </div>
  );
}

export const type: AgentTemplateWizardStepType = 'attach-webhook';
export const component = AttachWebhookStep;
